import { UserManagementPage } from '@/components/admin/user-management-page'

export function AdminStaffUsersPage() {
  return <UserManagementPage mode="staff" />
}
